import React from "react";
import { Typography, Tooltip } from "antd";
import { getLocalPhoneNumber } from "../util/helpers";
const { Text } = Typography;

const Phone = (props) => {
  const { text, ellipsis } = props;
  return ellipsis ? (
    <Tooltip
      className="content"
      placement="topLeft"
      title={text ? getLocalPhoneNumber(text) : ""}
    >
      {text ? getLocalPhoneNumber(text) : ""}
    </Tooltip>
  ) : (
    <Text>{text ? getLocalPhoneNumber(text) : ""}</Text>
  );
};

export default Phone;
